export default {
  // sm: `
  // Technology with a<br>
  // sincere heart
  // `,
  sm: `
  Standards of an<br> 
  eco-friendly<br> 
  data center  
  `,
  md: `
  Standards of an<br> 
  eco-friendly data center  
  `,
  lg: `
  Standards of an<br> 
  eco-friendly data center  
  `,
  xxl: `
  Standards of an<br> 
  eco-friendly data center  
  `,
};
